import React, { useState, useMemo } from "react";
import Scrollbars from "react-custom-scrollbars-2";
// import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "../../core/json/siderbar_data";
// import HorizontalSidebar from "./horizontalSidebar";
// import CollapsedSidebar from "./collapsedSidebar";

const Sidebar = () => {
  // const SidebarData = useSelector((state) => state.sidebar_data);
  // console.log(sidebarData, "sidebar");

  const Location = useLocation();

  console.log("Location.pathname", Location.pathname);

  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");

  // Read user permissions from localStorage
  const { userPermissions, isSuperAdmin } = useMemo(() => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      return {
        userPermissions: user.permissions || [],
        isSuperAdmin: user.role_slug === "super-admin",
      };
    } catch {
      return { userPermissions: [], isSuperAdmin: false };
    }
  }, []);

  // Filter sidebar data based on user permissions (non-mutating)
  const filteredSidebarData = useMemo(() => {
    if (isSuperAdmin) return SidebarData;

    return SidebarData.reduce((acc, section) => {
      // Hide entire section if the user lacks its permission
      if (section.permission && !userPermissions.includes(section.permission)) {
        return acc;
      }

      if (section.submenuItems && section.submenuItems.length > 0) {
        const filteredItems = section.submenuItems.reduce((subAcc, item) => {
          // Items that themselves have nested sub-menus (e.g. Expenses > Expense List)
          if (item.submenuItems && item.submenuItems.length > 0) {
            const filteredNested = item.submenuItems.filter(
              (nested) =>
                !nested.permission || userPermissions.includes(nested.permission)
            );
            if (
              filteredNested.length > 0 &&
              (!item.permission || userPermissions.includes(item.permission))
            ) {
              subAcc.push({ ...item, submenuItems: filteredNested });
            }
            return subAcc;
          }

          // Regular menu item
          if (!item.permission || userPermissions.includes(item.permission)) {
            subAcc.push(item);
          }
          return subAcc;
        }, []);

        if (filteredItems.length > 0) {
          acc.push({ ...section, submenuItems: filteredItems });
        }
        return acc;
      }

      acc.push(section);
      return acc;
    }, []);
  }, [userPermissions, isSuperAdmin]);

  const toggleSidebar = (title) => {
    if (title == subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem) => {
    if (subitem == subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };

  return (
    <div>
      <div className="sidebar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {filteredSidebarData?.map((mainLabel, index) => (
                  <li className="submenu-open" key={index}>
                    <h6 className="submenu-hdr">{mainLabel?.label}</h6>

                    <ul>
                      {mainLabel?.submenuItems?.map((title, i) => {
                        let link_array = [];
                        title?.submenuItems?.map((link) => {
                          link_array?.push(link?.link);
                          if (link?.submenu) {
                            link?.submenuItems?.map((item) => {
                              link_array?.push(item?.link);
                            });
                          }
                          return link_array;
                        });
                        title.links = link_array;
                        return (
                          <>
                            <li className="submenu" key={i}>
                              <Link
                                to={title?.link}
                                onClick={() => toggleSidebar(title?.label)}
                                className={`${subOpen == title?.label ? "subdrop" : ""
                                  } ${title?.links?.includes(Location.pathname)
                                    ? "active"
                                    : ""
                                  }
                            `}
                              >
                                {/* <Grid /> */}
                                {title?.icon}
                                <span>{title?.label}</span>
                                <span
                                  className={title?.submenu ? "menu-arrow" : ""}
                                />
                              </Link>
                              <ul
                                style={{
                                  display:
                                    subOpen == title?.label ? "block" : "none",
                                }}
                              >
                                {title?.submenuItems?.map(
                                  (item, titleIndex) => (
                                    <li
                                      className="submenu submenu-two"
                                      key={titleIndex}
                                    >
                                      {/* {item.lebel} */}
                                      <Link
                                        to={item?.link}
                                        className={
                                          item?.submenuItems
                                            ?.map((link) => link?.link)
                                            .includes(Location.pathname) ||
                                            item?.link == Location.pathname
                                            ? "active"
                                            : ""
                                        }
                                        onClick={() => {
                                          toggleSubsidebar(item?.label);
                                        }}
                                      >
                                        {item?.label}
                                        <span
                                          className={
                                            item?.submenu ? "menu-arrow" : ""
                                          }
                                        />
                                      </Link>
                                      <ul
                                        style={{
                                          display:
                                            subsidebar == item?.label
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        {item?.submenuItems?.map(
                                          (items, titleIndex) => (
                                            <li key={titleIndex}>
                                              {/* {item.lebel} */}
                                              <Link
                                                to={items?.link}
                                                className={`${subsidebar == items?.label
                                                  ? "submenu-two subdrop"
                                                  : "submenu-two"
                                                  } ${items?.submenuItems
                                                    ?.map((link) => link.link)
                                                    .includes(
                                                      Location.pathname
                                                    ) ||
                                                    items?.link ==
                                                    Location.pathname
                                                    ? "active"
                                                    : ""
                                                  }`}
                                              >
                                                {items?.label}
                                              </Link>
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    </li>
                                  )
                                )}
                              </ul>
                            </li>
                          </>
                        );
                      })}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
      {/* <HorizontalSidebar />
      <CollapsedSidebar /> */}
    </div>
  );
};

export default Sidebar;
